import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import './styles/modal-responsive.css';
import './styles/compact-viewport.css';
import App from './App';
import { StoreProvider } from './context/StoreContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <StoreProvider>
        <App />
    </StoreProvider>
);
